import { Component, type ReactNode } from 'react';

interface State {
  hasError: boolean;
  message?: string;
}

/** Top-level error boundary so a render error never leaves a blank screen. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message };
  }

  override componentDidCatch(error: Error) {
    console.error('Render error:', error);
  }

  override render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-bg px-4">
          <div className="panel max-w-md p-8 text-center">
            <h1 className="text-xl font-semibold text-text-primary">Something went wrong</h1>
            <p className="mt-2 text-sm text-text-secondary">
              The page ran into an unexpected error. Try reloading.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="mt-5 rounded-lg bg-accent-blue px-4 py-2 text-sm font-semibold text-white"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
